
<nav-bar></nav-bar>
<ng-container *ngIf="!ev1">
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev1')"></altcha-widget>
</ng-container>
<div class="scroller column">
  <div class="grid center-v" id="humanAndSearch">
    <div class="flex column">
      <queryParams2human [searchObj]="{asStructure:structure}"></queryParams2human>
    </div>
    <div class="buttons flex flex-end">
      <button class="search" w-button [isDefault]="true" label="{{'general_words.search' | translate}}" size="small" (click)="search()" [disabled]="!isSearchButtonActive || !ev1 "></button>
    </div>
  </div>
  <div class="grid" id="firstBrickContainer" [class.noButtons]="structure.bricks.length===1" (keyup.enter)="onEnterKey()">
    <brick id="firstBrick" [structure]="structure" [level]="0"></brick>
  </div>
  <h2 class="uppercase">{{ 'general_words.sort_by' | translate }}</h2>
  <div class="flex" id="sortOptions">
    <w-input-radio class="grow" [options]="sortOptions" (click)="onChangeSort($event)" [(ngModel)]="qs.queryParams.advancedsearch.sort"></w-input-radio>
    <div class="imageSimilarity flex grow" *ngIf="qs.queryParams.advancedsearch.sort==='image_similarity'">
      <div class="imageDrop level0 center-all animatedSlow column">
        <image-editor *ngIf="ms.editingImageIndex!==null; else imageDrop"></image-editor>
        <ng-template #imageDrop>
          <imagedrop [callback]="removeImageChangeSort"></imagedrop>
        </ng-template>
      </div>
      <w-input-radio class="grow" *ngIf="ms.bases64?.length && ms.editingImageIndex===null && ms.instanceType == 'gbd'" label="{{ 'page_similarlogo.refine_by' | translate }}" [options]="strategies" [(ngModel)]="qs.queryParams[ ms.endpoint ].strategy"></w-input-radio>
    </div>
  </div>
  <recent-searches [parentObject]="parent"></recent-searches>
</div>
